// extracted by mini-css-extract-plugin
module.exports = {"v1cp4m9y":"v1cp4m9y","mr538gr":"mr538gr","title":"title","ratio":"ratio"};